import { Skeleton } from 'components/Blocks';
import { loaders } from 'entities';
import { useUrlStateV2 } from 'hooks';
import { ChildrenProps } from 'react';
import { TokenStep } from './TokenStep';

export function TokenValidator({ children }: ChildrenProps) {
  const [{ token }] = useUrlStateV2({
    token: '',
  });

  const [result, { loading }] = loaders.auth.validatePasswordToken.useV2({
    disabled: !token?.trim(),
    params: { token },
  });

  if (loading) return <Skeleton height={96} />;

  if (result?.isValid) return <TokenStep token={token} />;

  return children;
}
